// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environmentName: 'web',
  chromeExtensionId: 'aiilihmgmhoficljcagckjnjggdcnmhc',
  webUrl: 'https://wlremember-bb01a.web.app',
  cloudFunctionsUrl: 'https://us-central1-wlremember-bb01a.cloudfunctions.net',
  cloudFunctionsRegion: 'us-central1',
  posthogKey: 'phc_nCQkNwzAqUkqeFnVCkNzuLcUyJeePfd84W4KffKAwdkQ',
  posthogHost: 'https://i.internalizeit.com',
  firebase : {
    apiKey: "AIzaSyDscRjZ4w1xi2w7GzES0tBu92gdLYxEWu4",
    authDomain: "wlremember-bb01a.firebaseapp.com",
    projectId: "wlremember-bb01a",
    storageBucket: "wlremember-bb01a.appspot.com",
    messagingSenderId: "1096287768796",
    appId: "1:1096287768796:web:cab0d08f9235e7d635e419",
    measurementId: "G-HCFSVYW0QW"


  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
